import { Button, Panel, PanelHead, useToast } from '@concord/ui';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api, errorMessage } from '../../lib/api';

/**
 * Admin access for a care navigator: data recovery and authenticator removal.
 * Only admins see this; nobody can remove their own admin access.
 */
export function AdminAccess({
  accountId,
  isAdmin,
  self,
}: {
  accountId: string;
  isAdmin: boolean;
  self: boolean;
}) {
  const qc = useQueryClient();
  const toast = useToast();
  const change = useMutation({
    mutationFn: (admin: boolean) =>
      api(`/staff/directory/account/${accountId}/admin`, { method: 'PATCH', body: { admin } }),
    onSuccess: async (_d, admin) => {
      await qc.invalidateQueries({ queryKey: ['account', accountId] });
      toast(admin ? 'Admin access granted.' : 'Admin access removed.');
    },
    onError: (e) => toast(errorMessage(e), 'bad'),
  });
  return (
    <Panel aria-label="Admin access">
      <PanelHead title="Admin access" sub={isAdmin ? 'Admin' : 'Not an admin'}>
        {!self && (
          <Button
            variant={isAdmin ? 'sec' : 'primary'}
            busy={change.isPending}
            onClick={() => change.mutate(!isAdmin)}
            style={{ marginLeft: 'auto' }}
          >
            {isAdmin ? 'Remove admin' : 'Make admin'}
          </Button>
        )}
      </PanelHead>
      <div className="pbody sub2">
        Admins can restore removed records and guests, and remove a lost authenticator app. The audit log is
        for super admins.{self ? ' You cannot remove your own admin access.' : ''}
      </div>
    </Panel>
  );
}
